<div class="container">
  <div class="container-3d">
    <div class="spinner-container">
      <ngx-spinner class="spinner" zIndex="100" color="rgba(245,62,133,1)" size="medium" [fullScreen]="false"
        bdColor="rgba(51,51,51,0)">
      </ngx-spinner>
    </div>
    <div class="label label-top" (click)="showTop()" pTooltip="{{'En haut' | translate}}" tooltipPosition="top">
      <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="4" width="44" height="44" rx="22" fill="#64A3F6" />
        <rect x="0.5" y="0.5" width="51" height="51" rx="25.5" stroke="#64A3F6" />
        <path d="M18 26H34" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M26 34L26 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <div class="label label-bottom" (click)="showBottom()" pTooltip="{{'En bas' | translate}}" tooltipPosition="top">
      <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="4" width="44" height="44" rx="22" fill="#64A3F6" />
        <rect x="0.5" y="0.5" width="51" height="51" rx="25.5" stroke="#64A3F6" />
        <path d="M18 26H34" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M26 34L26 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <div class="label label-common" (click)="showCommon()" pTooltip="{{'Communs' | translate}}" tooltipPosition="top">
      <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="4" width="44" height="44" rx="22" fill="#64A3F6" />
        <rect x="0.5" y="0.5" width="51" height="51" rx="25.5" stroke="#64A3F6" />
        <path d="M18 26H34" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M26 34L26 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <div class="info default">
      <div class="title">{{'Général' | translate}}</div>
      <div class="lines">
        <div class="line">
          <i class="fa fa-users"></i>
          6 {{'personnes ou plus' | translate}}
        </div>
        <div class="line">
          <i class="fa fa-bed"></i>
          3 {{'chambres' | translate}}
        </div>
        <div class="line">
          <i class="fa fa-shower"></i>
          3 {{'salles de bain' | translate}}
        </div>
        <div class="line">
          <i class="fa fa-utensils"></i>
          2 {{'cuisines' | translate}}
        </div>
        <div class="line">
          <i class="fa fa-fan"></i>
          {{'Air conditioné' | translate}}
        </div>
        <div class="line">
          <i class="fa fa-wifi"></i>
          Wifi
        </div>
        <div class="line">
          <i class="fa fa-swimmer"></i>
          {{'Piscine' | translate}}
        </div>
        <div class="line">
          <i class="fa fa-parking"></i>
          Parking
        </div>
      </div>
    </div>
    <div class="info top">
      <div class="cross" (click)="showDefault()"><i class="fa fa-times"></i></div>
      <div class="title">{{'Haut' | translate}}</div>
      <div class="lines">
        <div class="line">
          <i class="fa fa-bed"></i>
          <div class="line-container">
            {{'Chambre' | translate}}
            <div class="sub-line">
              2 {{'lits jumeaux 90x200' | translate}}, Smart TV
            </div>
          </div>
        </div>
        <div class="line">
          <i class="fa fa-shower"></i>
          <div class="line-container">
            {{'Salle de bain' | translate}}
            <div class="sub-line">
              {{'Douche' | translate}}, {{'Baignoire' | translate}}, {{'Lavabo' | translate}}, WC
            </div>
          </div>
        </div>
        <div class="line">
          <i class="fa fa-utensils"></i>
          <div class="line-container">
            {{'Cuisine' | translate}}
            <div class="sub-line">
              {{'Réfrigérateur' | translate}}, {{'Congélateur' | translate}}, {{'Cuisinière' | translate}},
              {{'grille-pain' | translate}}, {{'percolateur' | translate}}, {{'bouilloire' | translate}},
              {{'presse-agrumes' | translate}}, {{'four m-o' | translate}}...
            </div>
          </div>
        </div>
        <div class="line">
          <i class="fa fa-couch"></i>
          <div class="line-container">
            {{'Séjour' | translate}}
            <div class="sub-line">
              {{'Table repas' | translate}}, {{'Salon avec canapé-lit' | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info bottom">
      <div class="cross" (click)="showDefault()"><i class="fa fa-times"></i></div>
      <div class="title">{{'Bas' | translate}}</div>
      <div class="lines">
        <div class="line">
          <i class="fa fa-bed"></i>
          <div class="line-container">
            {{'Chambre' | translate}} 1
            <div class="sub-line">
              {{'Lit king-size 160x200' | translate}}
            </div>
          </div>
        </div>
        <div class="line">
          <i class="fa fa-shower"></i>
          <div class="line-container">
            {{'Salle de bain' | translate}} 1
            <div class="sub-line">
              {{'Baignoire' | translate}} + {{'douche' | translate}}, {{'Lavabo' | translate}}, WC
            </div>
          </div>
        </div>
        <div class="line">
          <i class="fa fa-bed"></i>
          <div class="line-container">
            {{'Chambre' | translate}} 2
            <div class="sub-line">
              {{'Lit king-size 160x200' | translate}}, minibar
            </div>
          </div>
        </div>
        <div class="line">
          <i class="fa fa-shower"></i>
          <div class="line-container">
            {{'Salle de bain' | translate}} 2
            <div class="sub-line">
              {{'Douche' | translate}}, {{'Lavabo' | translate}}, WC
            </div>
          </div>
        </div>
        <div class="line">
          <i class="fa fa-utensils"></i>
          <div class="line-container">
            {{'Cuisine' | translate}}
            <div class="sub-line">
              {{'Cuisine full équipée' | translate}}, {{'lave-vaisselle' | translate}}, {{'grille-pain' | translate}},
              {{'percolateur' | translate}}, {{'bouilloire' | translate}}, {{'presse-agrumes' | translate}},...
            </div>
          </div>
        </div>
        <div class="line">
          <i class="fa fa-couch"></i>
          <div class="line-container">
            {{'Séjour' | translate}}
            <div class="sub-line">
              {{'Table repas' | translate}}, {{'Bar' | translate}}, {{'Salon avec canapé-lit' | translate}}, Smart TV
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info common">
      <div class="cross" (click)="showDefault()"><i class="fa fa-times"></i></div>
      <div class="title">{{'Communs' | translate}}</div>
      <div class="lines">
        <div class="line">
          <i class="fa fa-sink"></i>
          <div class="line-container">
            {{'Buanderie' | translate}}
            <div class="sub-line">
              {{'Lave-linge' | translate}}, {{'Fer et table à repasser' | translate}}, {{'Etendoir' | translate}},
              {{'Aspirateur' | translate}}, {{'Ustensiles de ménage' | translate}}, WC
            </div>
          </div>
        </div>
        <div class="line">
          <i class="fa fa-sun"></i>
          <div class="line-container">
            {{'Extérieur' | translate}}
            <div class="sub-line">
              {{'Piscine 25m²' | translate}}, {{'Lits de soleil' | translate}}, {{'Douche' | translate}}, {{'Tables' |
              translate}}, {{'Chaises' | translate}}, {{'Parasols' | translate}}, {{'Barbecue' | translate}}, {{'Jardin'
              | translate}}
            </div>
          </div>
        </div>
        <div class="line">
          <i class="fa fa-info-circle"></i>
          <div class="line-container">
            <div class="sub-line" [innerHTML]="equipment1.text" (click)="updateText(equipment1, updateTextTemplate)">
            </div>
          </div>
        </div>
      </div>
    </div>
    <canvas id="c"></canvas>
    <div class="footer-info" *ngIf="currentPosition === Positions.default">
      <div class="wire-btn" [routerLink]="['/prices']">
        <span>{{'Découvrir les tarifs' | translate}}</span>
      </div>
    </div>
  </div>
</div>

<ng-template #updateTextTemplate>
  <div class="modal-content">
    <div class="header">
      Update text
      <div class="close" (click)="modalRef.hide()">
        <i class="fa fa-times"></i>
      </div>
    </div>
    <div class="content">
      <textarea rows="25" [(ngModel)]="textModel.text"></textarea>
    </div>
    <div class="footer">
      <button class="wire-btn" (click)="saveText()">Save</button>
      <button class="wire-btn default" (click)="modalRef.hide()">Cancel</button>
    </div>
  </div>
</ng-template>